import { defineStore } from "pinia";
import { getMyUploads, getUploadTokens, revokeUploadToken } from "@/services/api/tokenomics";
import { utc8 } from "@/shared/utils/format";
import { withRevokedToken } from "@/features/settings/model/tokens";
import { useAuthStore } from "@/stores/auth";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    myUploads: [],
    tokens: [],
    loading: false,
    error: null,
  }),
  getters: {
    todayUsage: (state) => state.myUploads.find((item) => item.date === utc8()) ?? null,
    activeTokens: (state) => state.tokens.filter((item) => !item.revokedAt),
    activeLegacyTokens() {
      return this.activeTokens.filter((item) => item.kind !== "native_mac");
    },
  },
  actions: {
    async loadSettings() {
      const auth = useAuthStore();
      if (!auth.user) return;
      this.loading = true;
      this.error = null;
      try {
        const today = utc8();
        const [mine, tokenList] = await Promise.all([
          getMyUploads({ from: today, to: today, provider: "all" }),
          getUploadTokens(),
        ]);
        this.myUploads = mine.items ?? [];
        this.tokens = tokenList.items ?? [];
      } catch (err) {
        this.error = err instanceof Error ? err.message : "加载失败";
      } finally {
        this.loading = false;
      }
    },
    async revokeUploadToken(id) {
      this.error = null;
      try {
        await revokeUploadToken(id);
        this.tokens = withRevokedToken(this.tokens, id);
      } catch (err) {
        this.error = err instanceof Error ? err.message : "撤销失败";
      }
    },
  },
});
